import React from 'react';
import { useRoughCanvas } from '@/hooks/useRoughCanvas';

interface RoughCardProps {
  children: React.ReactNode;
  active?: boolean;
  borderColor?: string;
  activeBorderColor?: string;
  strokeWidth?: number;
  activeStrokeWidth?: number;
  roughness?: number;
  activeFill?: 'none' | 'solid';
  activeFillColor?: string;
  seed?: number;
  className?: string;
  onClick?: () => void;
  padding?: string;
}

const RoughCard: React.FC<RoughCardProps> = ({
  children,
  active = false,
  borderColor = '#d2dae5',
  activeBorderColor = '#428fe9',
  strokeWidth = 1.5,
  activeStrokeWidth = 2.5,
  roughness = 0.8,
  activeFill = 'none',
  activeFillColor = 'rgba(66,143,233,0.05)',
  seed = 1,
  className = '',
  onClick,
  padding = '24px',
}) => {
  const canvasRef = useRoughCanvas(
    (rc, w, h) => {
      const currentColor = active ? activeBorderColor : borderColor;
      const currentStroke = active ? activeStrokeWidth : strokeWidth;
      const options: Record<string, unknown> = {
        stroke: currentColor,
        strokeWidth: currentStroke,
        roughness,
        seed,
      };
      if (active && activeFill !== 'none') {
        options.fill = activeFillColor;
        options.fillStyle = activeFill;
      }
      rc.rectangle(2, 2, w - 4, h - 4, options);
    },
    [active, borderColor, activeBorderColor, strokeWidth, activeStrokeWidth,
      roughness, seed, activeFill, activeFillColor],
  );

  return (
    <div
      className={`rough-card ${active ? 'rough-card--active' : ''} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); }
      } : undefined}
      style={{ padding }}
    >
      <canvas
        ref={canvasRef}
        className="rough-card__canvas"
        aria-hidden="true"
      />
      <div style={{ position: 'relative', zIndex: 1 }}>
        {children}
      </div>
    </div>
  );
};

export default RoughCard;
